import React, { useEffect, useState } from 'react';
import './App.css';
import { onAuthStateChanged, signInAnonymously } from 'firebase/auth';
import ChatRoom from './ChatRoom';
import Loading from 'react-loading';

// import signOutImage from './images/sign-out.png';
import questionImage from './images/question.svg';
import musie from './images/musie.png';
import musieJPG from './images/musie.jpg';
import logoWhiteImageBig from './images/logoWhiteBig.png'
import axios from 'axios';

import './tailwind.css';
import { auth, signInFunc } from "./firebase";
import { FirestoreClient } from './firestoreClient';


function App() {

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [vh, setVh] = useState(window.innerHeight);
  const [firestoreClient, setFirestoreClient] = useState(null);

  useEffect(() => {
    const start = performance.now();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      const end = performance.now();
      console.log(`Authentication took ${end - start} milliseconds`);

      if (user && user.uid) {
        setUser(user);
        const client = new FirestoreClient(user.uid);
        setFirestoreClient(client);
        await client.loginUserSession()
        setLoading(false);
      } else {
        try {
          await signInAnonymously(auth);
        } catch (error) {
          console.error('Error signing in anonymously: ', error);
        }
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();

  }, [auth]); // Pass auth as dependency to useEffect to avoid unnecessary re-renders

  useEffect(() => {
    const handleResize = () => {
      setTimeout(() => {
        setVh(window.innerHeight);
      }, 150); // slight delay, because in some cases the browser is not fast enough
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Create lockScroll function
  const lockScroll = () => {
    document.body.style.position = 'fixed';
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
  };

  // Create unlockScroll function
  const unlockScroll = () => {
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  };

  // Add an effect that locks the scroll on mount and unlocks on unmount
  useEffect(() => {
    lockScroll();
    return unlockScroll;
  }, []);



  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <div>Error: Could not authenticate user</div>;
  }

  const vhInPx = `${vh}px`;

  return (
    <div className="h-screen flex flex-col justify-center items-center bg-slate-200 overflow-hidden"
      style={{ height: vhInPx }}>
      <div className="max-w-lg w-full flex flex-col h-full">
        <header className="sticky flex items-center justify-between p-5 bg-white border-b-4 border-[#F49201]">
          <a href="https://fantamusie.de" target="_self">
            <img className="w-11 h-11 rounded-full" src={logoWhiteImageBig} alt="?"/>
          </a>
          <h1 className="text-2xl font-semibold text-gray-900">Musie</h1>
          <Help />
        </header>

        <section className="flex-grow flex flex-col bg-[#FEECD0] overflow-auto">
          <ChatRoom firestoreClient={firestoreClient} />
        </section>
      </div>
    </div>
  );
}


function Help() {
  return (
    <div className="flex items-center justify-center w-12 h-12 rounded-full">
      <img className="w-12 h-12 rounded-full" src={musie} alt="?" />
    </div>
  );
}

function LoadingScreen() {

  return (
    <div className="flex flex-col items-center justify-center min-h-screen sm:min-h-auto bg-[#FEECD0]">
      <img className='company-logo w-40 h-40 object-cover rounded-full' src={musie} alt="Company Logo" />
      <h1 className="title text-3xl font-bold text-black mt-8">Musie</h1>
      <Loading type={'bubbles'} color={'#000000'} height={'20%'} width={'20%'} />
      <p className="loading-text text-xl md:text-2xl text-black mt-4">lädt ...</p>
    </div>
  );
}


export default App;
